import React from 'react';
import {
  ScrollView as RNScrollView,
  ScrollViewProps,
} from 'react-native';
import { SxProp } from 'dripsy';

import { useSxProp } from '@hooks';

export interface IScrollViewProps extends ScrollViewProps {
  contentContainerSx?: SxProp;
}

export function ScrollView(props: IScrollViewProps) {
  const contentContainerStyle = useSxProp({
    styleProp: props.contentContainerStyle,
    sxProp: props.contentContainerSx,
  });

  return (
    <RNScrollView
      {...props}
      contentContainerStyle={contentContainerStyle}
    />
  );
}
